// Global search result types and interfaces
export enum EquipmentGlobalSearchResultType {
    EQUIPMENT = 'equipment',
    PACKAGE_CONTENT = 'package_content',
}

export type GlobalEquipmentSearchResult = {
    id: string
    equipmentId: string
    equipmentEvaKey?: string
    equipmentName: string
    equipmentGroupId: string
    equipmentFamilyName?: string
    matchedText: string
    type: EquipmentGlobalSearchResultType
    packageParentId?: string
    packageParentName?: string
}

export default GlobalEquipmentSearchResult
